<!-- ================= HERO ================= -->
<section class="hero">
  <div class="wrap hero-grid">
    <div class="hero-copy">
      <span class="eyebrow" i18n="@@featOverview.heroEyebrow">Features</span>
      <h1 i18n="@@featOverview.heroTitle">Alle Features auf einen Blick</h1>
      <p class="lead" i18n="@@featOverview.heroLead">Von Live-Link bis Rabatte &amp; Kampagnen: Entdecke, was deine marktbox alles kann – zentral gesteuert in einer App.</p>
      <div class="hero-actions">
        <a class="btn btn-primary" href="#features" (click)="scrollTo($event, 'features')" i18n="@@featOverview.heroCtaFeatures">Features entdecken
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
        </a>
        <a class="btn btn-ghost" href="#anfrage" (click)="scrollTo($event, 'anfrage')" i18n="@@featOverview.heroCtaContact">Kontakt aufnehmen</a>
      </div>
    </div>
    <div class="hero-media">
      <div class="iphone">
        <div class="iphone-screen">
          <div class="app" aria-label="marktbox-App · Verkäufe">
            <div class="ap-status"><span>18:42</span><span>5G</span></div>
            <div class="ve-bar">
              <span class="ve-back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M15 18l-6-6 6-6"/></svg>Back</span>
              <span class="ve-ttl">Verkäufe</span>
              <span class="ve-dots">•••</span>
            </div>
            <div class="ve-total">
              <div class="ve-sum">4.860,00 <span>EUR</span></div>
              <div class="ve-tags">
                <span class="ve-tag"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/></svg></span>
                <span class="ve-tag">EUR</span>
              </div>
            </div>
            <div class="ve-range">
              <div><div class="l">Von</div><div class="d">02.07.2026</div></div>
              <div class="r"><div class="l">Bis</div><div class="d">02.08.2026</div></div>
            </div>
            <div class="ve-chart">
              <div class="ve-yl"><span>800</span><span>600</span><span>400</span><span>200</span><span>0</span></div>
              <div class="ve-plot">
                <i style="height:60%"></i><i style="height:76%"></i><i style="height:0"></i>
                <i style="height:27%"></i><i style="height:18%"></i><i style="height:21%"></i><i style="height:11%"></i><i style="height:11%"></i><i style="height:11%"></i><i style="height:0"></i>
                <i style="height:8%"></i><i style="height:2%"></i><i style="height:2%"></i><i style="height:4%"></i><i style="height:0"></i>
                <i style="height:20%"></i><i style="height:38%"></i><i style="height:24%"></i><i style="height:16%"></i><i style="height:27%"></i><i style="height:56%"></i>
                <i style="height:26%"></i><i style="height:24%"></i><i style="height:32%"></i><i style="height:46%"></i>
              </div>
            </div>
            <div class="ve-x"><span>03 Jul</span><span>11 Jul</span><span>19 Jul</span><span>27 Jul</span></div>
            <div class="ve-legend"><span><i class="bl"></i>Verkäufe in EUR</span><span><i class="gr"></i>Rabatte in EUR</span></div>
            <div class="ve-auto">
              <div class="ve-auto-h"><span class="t">Automaten</span><span class="asc">DESC</span></div>
              <div class="ve-arow"><span class="n">Musterautomat Nord</span><span class="v">2.900,00 <small>EUR</small></span><span class="chev">›</span></div>
              <div class="ve-arow"><span class="n">Musterautomat Süd</span><span class="v">1.960,00 <small>EUR</small></span><span class="chev">›</span></div>
            </div>
          </div>
        </div>
        <span class="iphone-btn volup"></span>
        <span class="iphone-btn voldn"></span>
        <span class="iphone-btn power"></span>
      </div>
    </div>
  </div>
</section>

<!-- ================= KUNDENSTIMMEN ================= -->
<section class="testi-strip">
  <div class="ts-lead reveal" i18n="@@featOverview.testiLead">Das sagen marktbox-Betreiber</div>
  <div class="ts-grid">
    @for (t of testimonials; track t.name) {
      <div class="ts-card reveal">
        <div class="ts-stars">
          @for (s of [1,2,3,4,5]; track s) {
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 17.3 5.8 20.6l1.6-6.7L2.2 8.9l6.9-.6z"/></svg>
          }
        </div>
        <p class="ts-quote">„{{ t.quote }}"</p>
        <div class="ts-by"><span class="ts-av">{{ t.initials }}</span><div><div class="ts-nm">{{ t.name }}</div><div class="ts-ro">{{ t.role }}</div></div></div>
      </div>
    }
  </div>
</section>

<!-- ================= FEATURE-KACHELN ================= -->
<section class="section" id="features">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow" i18n="@@featOverview.featuresEyebrow">Features</span>
      <h2 i18n="@@featOverview.featuresTitle">Stell dir deine Features zusammen</h2>
      <p i18n="@@featOverview.featuresText">Öffne ein Feature für alle Details – oder leg es mit „Hinzufügen" direkt in deine Auswahl. Am Ende schickst du sie uns mit einem Klick als unverbindliche Anfrage.</p>
    </div>
    <div class="feature-grid">
      @for (f of features; track f.slug) {
        <div class="fcard reveal" [class.selected]="isSel(f.slug)"
             [attr.role]="f.hasPage ? 'link' : null" [attr.tabindex]="f.hasPage ? 0 : null"
             [attr.aria-label]="f.hasPage ? 'Zur Feature-Seite: ' + f.title : null" (click)="open($event, f)"
             (keydown.enter)="open($event, f)" (keydown.space)="$event.preventDefault(); open($event, f)">
          <div class="fc-preview" [class.pv-center]="f.slug === 'pin-login'">
            @switch (f.slug) {
              @case ('live-link') {
                <div class="pv-head"><span class="live-dot"></span>Live · Bäckerei Tews</div>
                <div class="mrow"><span class="mthumb"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 11c2-4 14-4 16 0l-1 8H5z"/></svg></span><span class="mtxt"><span class="mnm">Bauernbrot</span><span class="msb">verfügbar</span></span><span class="mpr">3,50 €</span></div>
                <div class="mrow"><span class="mthumb b"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 3v6a5 5 0 0 0 10 0V3"/></svg></span><span class="mtxt"><span class="mnm">Apfelschorle</span><span class="msb">verfügbar</span></span><span class="mpr">1,50 €</span></div>
              }
              @case ('reservierung') {
                <div class="pv-head">Reservierungen · heute</div>
                <div class="mrow"><span class="mcheck"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span class="mtxt"><span class="mnm">Sonntagsbrötchen ×6</span><span class="msb">Abholung 8:00</span></span><span class="mbadge green">Reserviert</span></div>
                <div class="mrow"><span class="mcheck"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span class="mtxt"><span class="mnm">Bauernbrot ×1</span><span class="msb">Abholung 9:30</span></span><span class="mbadge green">Reserviert</span></div>
              }
              @case ('presets') {
                <div class="pv-head">Fachbelegung · Vorlage „Werktags"</div>
                <div class="fachgrid">
                  <i class="half"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 11c2-4 14-4 16 0l-1 8H5z"/></svg></i>
                  <i></i>
                  <i class="on"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 11c2-4 14-4 16 0l-1 8H5z"/></svg></i>
                  <i class="half"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12c0-3 3-5 7-5s7 2 7 5-3 3-7 3-7 0-7-3z"/><path d="M7 12l-2 5M17 12l2 5"/></svg></i>
                  <i></i>
                  <i class="half"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 9a3 3 0 1 1 5 2 3 3 0 1 1 5-2"/><path d="M7 9c-2 3 1 9 5 9s7-6 5-9"/></svg></i>
                  <i class="half"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 11c2-4 14-4 16 0l-1 8H5z"/></svg></i>
                  <i></i>
                  <i class="half"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12c0-3 3-5 7-5s7 2 7 5-3 3-7 3-7 0-7-3z"/><path d="M7 12l-2 5M17 12l2 5"/></svg></i>
                  <i></i>
                </div>
              }
              @case ('notifications') {
                <div class="pv-head">Push · Sperrbildschirm</div>
                <div class="pushcard">
                  <span class="pi">m</span>
                  <span class="pt">
                    <span class="pr"><span>MARKTBOX</span><span>jetzt</span></span>
                    <span class="ph">Niedriger Bestand</span>
                    <span class="ps">Bauernbrot – nur noch 2 Stück</span>
                  </span>
                </div>
              }
              @case ('reinigungsprotokoll') {
                <div class="pv-head">Reinigungsprotokoll · KW 31</div>
                <div class="mrow"><span class="mcheck"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span class="mtxt"><span class="mnm">Innenraum gereinigt</span><span class="msb">Mo · 07:15</span></span></div>
                <div class="mrow"><span class="mcheck"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span class="mtxt"><span class="mnm">Fächer desinfiziert</span><span class="msb">Mi · 06:50</span></span></div>
              }
              @case ('sales-export') {
                <div class="pv-head">Export · Juli 2026</div>
                <div class="receipt"><div class="rc-l m"></div><div class="rc-l s"></div><div class="rc-l m"></div><div class="rc-tot"><span>Gesamt</span><span>2.480,50 €</span></div></div>
                <div class="fmt"><span>PDF</span><span>CSV</span><span class="hl">DATEV</span></div>
              }
              @case ('hinterlegen') {
                <div class="pv-head">Abholung · per Code</div>
                <div class="locker">
                  <span class="lk-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg></span>
                  <span class="lk-code"><span class="lk-dots"><i class="f"></i><i class="f"></i><i class="f"></i><i></i></span><span class="lk-cap">Fach 3 · Code eingeben</span></span>
                </div>
              }
              @case ('retourenanalyse') {
                <div class="pv-head">Retouren · pro Tag</div>
                <div class="bars"><i style="height:40%"></i><i style="height:65%"></i><i style="height:30%"></i><i class="a" style="height:80%"></i><i style="height:52%"></i><i style="height:35%"></i></div>
                <div class="bars-x"><span>Mo</span><span>Di</span><span>Mi</span><span>Do</span><span>Fr</span><span>Sa</span></div>
              }
              @case ('mitarbeiterverwaltung') {
                <div class="pv-head">Team &amp; Rollen</div>
                <div class="mrow"><span class="mtxt"><span class="mnm">Lukas</span></span><span class="mbadge y">Admin</span></div>
                <div class="mrow"><span class="mtxt"><span class="mnm">Maria B.</span></span><span class="mbadge green">Bearbeiter</span></div>
                <div class="mrow"><span class="mtxt"><span class="mnm">Tom S.</span></span><span class="mbadge violet">Befüller</span></div>
              }
              @case ('rabatte-kampagnen') {
                <div class="pv-head">Kampagnen · 2 aktiv</div>
                <div class="mrow"><span class="mtxt"><span class="mnm">Spargelwoche</span><span class="msb">Direkt · Spargelbrot</span></span><span class="mbadge y">−10%</span><span class="mtoggle on"></span></div>
                <div class="mrow"><span class="mtxt"><span class="mnm">Neukunden-Rabatt</span><span class="msb">Coupon · WILLKOMMEN</span></span><span class="mbadge ink">−3 €</span><span class="mtoggle on"></span></div>
              }
              @case ('pin-login') {
                <div class="pv-head">Login am Automaten</div>
                <div class="pin-dots"><i class="f"></i><i class="f"></i><i class="f"></i><i></i></div>
                <div class="pin-pad">
                  <span>1</span><span>2</span><span>3</span>
                  <span>4</span><span>5</span><span>6</span>
                  <span>7</span><span>8</span><span>9</span>
                  <span class="k">·</span><span>0</span><span class="k">⌫</span>
                </div>
              }
            }
          </div>
          <div class="fc-body">
            <div class="fc-title">{{ f.title }} @if (f.badge) { <span class="fc-badge" [class.fc-badge--beta]="f.badge === 'Beta'">{{ f.badge }}</span> }</div>
            <p class="fc-text">{{ f.text }}</p>
            <div class="fc-foot">
              @if (f.hasPage) {
                <span class="fc-more" (click)="open($event, f)" i18n="@@featOverview.cardMore">Mehr erfahren <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14M12 5l7 7-7 7"/></svg></span>
              }
              <button type="button" class="fc-add" [attr.aria-pressed]="isSel(f.slug)"
                      [attr.aria-label]="(isSel(f.slug) ? 'Aus Anfrage entfernen: ' : 'Zur Anfrage hinzufügen: ') + f.title"
                      (click)="addToggle($event, f.slug)"></button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- ================= BAND ================= -->
<div class="band">
  <div class="wrap">
    @for (s of stats; track s.label) {
      <div class="stat"><div class="n" [attr.data-count]="s.count ?? null" [attr.data-suffix]="s.suffix ?? null">{{ s.display }}</div><div class="t">{{ s.label }}</div></div>
    }
  </div>
</div>

<!-- ================= ANFRAGE / WARENKORB ================= -->
<section class="section anfrage" id="anfrage">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow" i18n="@@featOverview.anfrageEyebrow">Deine Auswahl</span>
      <h2 i18n="@@featOverview.anfrageTitle">Feature-Anfrage zusammenstellen</h2>
      <p i18n="@@featOverview.anfrageText">Deine ausgewählten Features findest du hier. Schick sie uns unverbindlich – wir melden uns mit einem passenden Angebot.</p>
    </div>
    <div class="order-grid">
      <div class="order-box" aria-live="polite">
        @if (selectedCount() === 0) {
          <h3 i18n="@@featOverview.selEmptyTitle">Deine Auswahl</h3>
          <p class="ol-empty" i18n="@@featOverview.selEmptyText">Noch keine Features ausgewählt. Klick oben auf die Features, die du buchen möchtest.</p>
        } @else {
          <h3 i18n="@@featOverview.selTitle">Deine Auswahl ({{ selectedCount() }})</h3>
          @for (f of selectedFeatures(); track f.slug) {
            <div class="ol-item"><span class="ol-name">{{ f.title }}</span><button type="button" class="ol-x" (click)="remove(f.slug)" aria-label="Entfernen" i18n-aria-label="@@featOverview.removeAria">&times;</button></div>
          }
        }
      </div>
      <div class="order-box">
        @if (sent()) {
          <div class="order-done">
            <div class="od-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg></div>
            <h3 i18n="@@featOverview.doneTitle">Danke, deine Anfrage ist raus!</h3>
            <p i18n="@@featOverview.doneText">Wir haben deine Auswahl erhalten und melden uns zeitnah bei dir.</p>
          </div>
        } @else {
          <form class="order-form" (ngSubmit)="submit()">
            <label for="of-name" i18n="@@featOverview.formName">Name</label>
            <input id="of-name" type="text" name="name" [(ngModel)]="name" autocomplete="name" placeholder="Vor- und Nachname" i18n-placeholder="@@featOverview.formNamePh">
            <label for="of-email" i18n="@@featOverview.formEmail">E-Mail *</label>
            <input id="of-email" type="email" name="email" [(ngModel)]="email" autocomplete="email" placeholder="name@betrieb.de" i18n-placeholder="@@featOverview.formEmailPh" required>
            <label for="of-msg" i18n="@@featOverview.formMsg">Nachricht (optional)</label>
            <textarea id="of-msg" name="message" [(ngModel)]="message" placeholder="Standort, Anzahl Automaten, Wunschtermin …" i18n-placeholder="@@featOverview.formMsgPh"></textarea>
            <button type="submit" class="btn btn-primary order-submit" [disabled]="selectedCount() === 0 || sending()">
              {{ sending() ? 'Wird gesendet …' : 'Anfrage senden' }}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </button>
            <p class="order-hint" i18n="@@featOverview.orderHint">Unverbindlich &middot; wir melden uns zeitnah zurück.</p>
          </form>
        }
      </div>
    </div>
  </div>
</section>

<!-- ================= FIXE AUSWAHL-LEISTE (unten) ================= -->
@if (selectedCount() > 0) {
<div class="select-bar" role="region" aria-label="Deine Feature-Auswahl" i18n-aria-label="@@featOverview.selectBarAria">
  <div class="wrap select-bar__inner">
    <div class="select-bar__list">
      <span class="select-bar__count" i18n="@@featOverview.selectBarCount">{{ selectedCount() }} {{ selectedCount() === 1 ? 'Feature' : 'Features' }} ausgewählt</span>
      <div class="select-bar__chips">
        @for (f of selectedFeatures(); track f.slug) {
          <span class="select-bar__chip">{{ f.title }}<button type="button" (click)="remove(f.slug)" [attr.aria-label]="'Entfernen: ' + f.title">&times;</button></span>
        }
      </div>
    </div>
    <a class="btn btn-primary select-bar__cta" href="#anfrage" (click)="scrollTo($event, 'anfrage')" i18n="@@featOverview.selectBarCta">Anfrage stellen
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
    </a>
  </div>
</div>
}

